import React from 'react';

import Paper from '@material-ui/core/Paper';

import classes from './CompanyCard.module.css';

const companyCard = props => {
    return (
        <Paper className={props.expandCard ? `${classes.esmsCardContainer} ${classes.expandCard}` : `${classes.esmsCardContainer}`}>
            <h2>{props.title}</h2>
            <div className={classes.esmsCardContents}>
                {props.children}
            </div>
        </Paper>
    );
};

export default companyCard;
